import { React, PropTypes, Row, Col, FelaComponent, FlipMove, noop } from '../dependencies';

import Restaurant from './Restaurant';

const restaurantsRule = () => ({
    position: 'relative',
});

const Restaurants = ({ restaurants, toggleRestaurantFavourite }) => (
    <FelaComponent
        rule={restaurantsRule}
        render={({ className }) => (
            <Row type="flex" className={className}>
                <FlipMove typeName={null}>
                    {restaurants.map(restaurant => (
                        <Col xs={24} sm={24} md={12} xl={8} key={restaurant.id}>
                            <Restaurant {...restaurant} toggleRestaurantFavourite={toggleRestaurantFavourite} />
                        </Col>
                    ))}
                </FlipMove>
            </Row>
        )}
    />
);

Restaurants.propTypes = {
    restaurants: PropTypes.arrayOf(PropTypes.shape(Restaurant.propTypes)),
    toggleRestaurantFavourite: PropTypes.func,
};

Restaurants.defaultProps = {
    restaurants: [],
    toggleRestaurantFavourite: noop,
};

export default Restaurants;
